module.exports = __webpack_public_path__ + "static/24-0cdfd8f7b24753aa12a5825fde642220.png";